import * as React from 'react';
export const SVGComponent = (props) => (
  <svg
    height={16}
    viewBox='0 0 19.087 42.608'
    width={16}
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M152.611,40.819V14.57a.715.715,0,0,1,1.43.025V24.17a1.663,1.663,0,0,0,3.326,0V15.332c0-3.528-1.575-6.74-5.512-6.74h-1.562a14.352,14.352,0,0,1-2.469,1.128,14.351,14.351,0,0,1-2.469-1.128h-1.562c-3.931,0-5.512,3.219-5.512,6.74V24.17a1.663,1.663,0,0,0,3.326,0V14.6a.715.715,0,0,1,1.43,0V40.819a1.792,1.792,0,0,0,3.584,0V27.748c0-.92-.132-2.305,1.2-2.305s1.209,1.386,1.209,2.305V40.819a1.792,1.792,0,0,0,3.584,0ZM147.817,0a3.424,3.424,0,1,1-3.42,3.427A3.43,3.43,0,0,1,147.817,0Zm0,10.973a1.011,1.011,0,0,1,1.008,1.008V18.74a1.008,1.008,0,0,1-2.016,0V11.981A1.011,1.011,0,0,1,147.817,10.973Z'
      data-name='Path 4381'
      fill='#007e75'
      fillRule='evenodd'
      id='Path_4381'
      transform='translate(-138.28)'
    />
  </svg>
);
